const scoreAddTicheng = () => import('@/views/main/score/commission/add/add.vue')
export default {
  path: '/main/score/scoreAddTicheng',
  name: 'scoreAddTicheng',
  component:scoreAddTicheng,
  children: []
}
